import { constants } from '@eti/utils';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { baggagePricePerTraveler } from '../../../common/utils/baggageUtils';
export const useSecondBaggage = ({
  travelerNumber,
  orderSecondBag
}) => {
  var _baggagePricePerTrave, _eligibleSecondBagTra, _orderSecondBag$sellS, _orderSecondBag$sellS2;
  const secondBagTravelers = (_baggagePricePerTrave = baggagePricePerTraveler(orderSecondBag)) !== null && _baggagePricePerTrave !== void 0 ? _baggagePricePerTrave : [];
  const eligibleSecondBagTravelers = secondBagTravelers.filter(({
    ageType
  }) => ageType !== constants.ageTypes.INFANT);
  const secondBagTraveler = (_eligibleSecondBagTra = eligibleSecondBagTravelers[travelerNumber]) !== null && _eligibleSecondBagTra !== void 0 ? _eligibleSecondBagTra : {};
  const options = (_orderSecondBag$sellS = orderSecondBag === null || orderSecondBag === void 0 || (_orderSecondBag$sellS2 = orderSecondBag.sellSpecification) === null || _orderSecondBag$sellS2 === void 0 || (_orderSecondBag$sellS2 = _orderSecondBag$sellS2.sellPriceBaggage) === null || _orderSecondBag$sellS2 === void 0 || (_orderSecondBag$sellS2 = _orderSecondBag$sellS2[0]) === null || _orderSecondBag$sellS2 === void 0 ? void 0 : _orderSecondBag$sellS2.options) !== null && _orderSecondBag$sellS !== void 0 ? _orderSecondBag$sellS : [];
  return {
    secondBagOptions: options,
    secondBagTraveler,
    secondBagTravelers: eligibleSecondBagTravelers,
    hasSecondBag: options.length > 0
  };
};
//# sourceMappingURL=useSecondBag.js.map